import React from 'react';
import { useTranslation } from 'react-i18next';
import sanitizeHtml from 'sanitize-html';
import { checkVietNam } from '@src/utils/checkCountry';
import { formatPrice } from '@src/services/package';
import { PACKAGE_LEVEL } from '@src/constants/package';
import Text from '../Shared/Text';
import CheckOrCross from '../Shared/CheckOrCross';

const getPricePerVoice = (pkg, language) => {
  const isVietNam = checkVietNam();
  const pricePerVoice = isVietNam
    ? pkg?.customResource?.voiceClonings?.prices?.[0]?.vndPricePerUnit
    : pkg?.customResource?.voiceClonings?.prices?.[0]?.usdPricePerUnit;

  return formatPrice({
    vndPrice: pricePerVoice,
    usdPrice: pricePerVoice,
    isVietNam,
    language,
  });
};

const ShowPricePerVoice = ({ pkg }) => {
  const { t, i18n } = useTranslation();
  const { language } = i18n;
  const pricePerVoice = getPricePerVoice(pkg, language);
  const description = pkg?.customResource?.voiceClonings?.description;

  return (
    <Text
      key={pkg.code}
      html={
        <div
          // eslint-disable-next-line react/no-danger
          dangerouslySetInnerHTML={{
            __html: sanitizeHtml(
              t(description[language], {
                pricePerUnit: pricePerVoice,
              }),
              {
                allowedTags: ['span'],
                allowedAttributes: {
                  span: ['style'],
                },
              },
            ),
          }}
        />
      }
    />
  );
};

const purchaseAdditionalProVoiceFeatures = ({ packages }) =>
  packages.map((pkg) =>
    pkg?.level === PACKAGE_LEVEL.CUSTOM ? (
      <ShowPricePerVoice key={pkg.code} pkg={pkg} />
    ) : (
      <CheckOrCross key={pkg.code} isCheck={false} />
    ),
  );

export default purchaseAdditionalProVoiceFeatures;
